import type { useFormatNumber } from 'core/hooks/useFormatNumber'

export enum InputType {
  PERCENTAGE = 'PERCENTAGE',
  PERCENTAGE_PRECISE = 'PERCENTAGE_PRECISE',
  AMOUNT = 'AMOUNT',
  AMOUNT_PRECISE = 'AMOUNT_PRECISE'
}

export interface InputTypeConfig {
  decimals: number
  // displayed value = stored value × 10^scaleExponent (e.g. a 0.123 ratio is displayed as 12.3 %)
  scaleExponent: number
  format: (value: number, decimals: number, scaleExponent: number) => string
}

export interface InputFormatters {
  formatNumber: ReturnType<typeof useFormatNumber>
}

const fixedDigits = (decimals: number): Intl.NumberFormatOptions => ({
  minimumFractionDigits: decimals,
  maximumFractionDigits: decimals,
  signDisplay: 'negative'
})

export const buildInputTypeConfigs = ({ formatNumber }: InputFormatters): Record<InputType, InputTypeConfig> => {
  const format: InputTypeConfig['format'] = (value, decimals, scaleExponent) =>
    formatNumber(value * 10 ** scaleExponent, '', fixedDigits(decimals))

  const percentage: InputTypeConfig = { decimals: 1, scaleExponent: 2, format }
  const amount: InputTypeConfig = { decimals: 0, scaleExponent: 0, format }

  return {
    [InputType.PERCENTAGE]: percentage,
    [InputType.PERCENTAGE_PRECISE]: { ...percentage, decimals: 2 },
    [InputType.AMOUNT]: amount,
    [InputType.AMOUNT_PRECISE]: { ...amount, decimals: 2 }
  }
}
